import { useSelector } from 'react-redux'
import { selectToken } from '../authentication/authenticationSlice'
import api from '../api'
import useDataLoader from '../dataLoader'

const useListAccountsWithWarnings = () => {
  const token = useSelector(selectToken)
  const fetchAccountsWithWarnings = async (organizationId) => {
    if (organizationId) {
      return await api.getAccountsWithWarnings({ token, organizationId })
    } else {
      return []
    }
  }

  return useDataLoader(fetchAccountsWithWarnings, [], [])
}

export default useListAccountsWithWarnings
